module.exports = __webpack_public_path__ + "img/wansa-wood.b46bfc46.webp";